import React from 'react';
import { useTranslation } from 'react-i18next';
import { MarketButton, MarketHeader } from '@market/react';
import { useCheckoutFlow } from 'components/context/checkout_flow';
import { isPOBoxBlocked } from 'utilities/po_box';
import { Dialog, DialogActions, DialogContent, useTheme } from '@mui/material';

const POBoxMessage = (props) => {
  const theme = useTheme();
  const { t } = useTranslation();
  const { orderData } = useCheckoutFlow();

  const { open, handleContinue, handleDismiss } = props;

  const dismissible = !isPOBoxBlocked(orderData);
  const ineligibleProducts = orderData.cart_summary
    .filter(({ pobox_eligible }) => !pobox_eligible)
    .map(({ product_variant }) => product_variant.title);

  return (
    <Dialog fullWidth maxWidth="sm" open={open} onClose={handleDismiss}>
      <MarketHeader style={{ margin: theme.spacing(4, 4, 1) }}>
        <h1>
          {dismissible
            ? t('checkout.shipping.poBox.allowTitle')
            : t('checkout.shipping.poBox.blockTitle')}
        </h1>
      </MarketHeader>
      <DialogContent sx={{ px: 4, py: 1 }}>
        {dismissible ? (
          <p>{t('checkout.shipping.poBox.allowMessage')}</p>
        ) : ineligibleProducts.length > 0 ? (
          <>
            <p>
              {t('checkout.shipping.poBox.blockMessage.ineligibleProducts')}
            </p>
            <br />
            <ul>
              {ineligibleProducts.map((name) => (
                <li className="paragraph-30" key={name}>
                  - {name}
                </li>
              ))}
            </ul>
          </>
        ) : (
          <p>{t('checkout.shipping.poBox.blockMessage.default')}</p>
        )}
      </DialogContent>
      <DialogActions sx={{ px: 4, pt: 1, pb: 4 }}>
        <MarketButton
          id="po-box-go-back-btn"
          onClick={handleDismiss}
          style={{ width: '100%' }}
        >
          {t('checkout.shipping.poBox.goBack')}
        </MarketButton>
        {dismissible && (
          <MarketButton
            id="po-box-continue-btn"
            rank="primary"
            onClick={handleContinue}
            style={{ width: '100%' }}
          >
            {t('checkout.shipping.poBox.continue')}
          </MarketButton>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default POBoxMessage;
